import { render, staticRenderFns } from "./EditCompanyForm.vue?vue&type=template&id=61859d14&"
import script from "./EditCompanyForm.vue?vue&type=script&lang=ts&"
export * from "./EditCompanyForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports